<template>
    <div>
        <div style="margin-bottom: 50px;">
            <a-form layout='inline'>
                <a-row :gutter='24'>
                    <a-form-item label="CustomerId">
                        <a-input v-model='custInfoId' />
                    </a-form-item>
                    <a-form-item><a-button type='primary' @click='search()'>
                            Search</a-button></a-form-item>
                </a-row>

            </a-form>
        </div>
        <div>
            <a-table key="id" ref="table" :columns="columns" :dataSource="dataSource" :pagination="pagination"
                :loading="isLoading" bordered @change="handleTableChange">
                <span slot="StartTime" slot-scope="text, record">
                    <p>{{ timestampToDate(record.startTime) }}</p>
                </span>
                <span slot="data" slot-scope="text, record">
                    <p v-for="(value, key, index) in record.data" :key="index">{{ key == 'endTime' || key == 'startTime'
                        ?
                        key + " : " + timestampToDate(value) : key +" : " + value }}</p>
                </span>
            </a-table>
        </div>
        <!-- <div class="timeLineBox">
                <div class="timeLineItem" v-for="(item, index) in timeLineData" :key="index">
                    <div class="yuan"></div>
                    <div class="contentText" v-if="item.level == 'page'">{{ item.pageName + " " + item.type + " " +
                        timestampToDate(item.StartTime) }}</div>
                    <div class="contentText" v-if="item.level == 'element'">{{ `${item.elementName} of ${item.pageName}
                        ${item.type} ${timestampToDate(item.StartTime)}` }}</div>
                    <div class="contentText" v-if="item.level == 'application'">{{ item.level + " " + item.type + " " +
                        timestampToDate(item.StartTime) }}</div>
                    <div class="contentText" v-if="item.level == 'input'">{{ `${item.elementName} of ${item.pageName}
                        ${item.type} from ${item.data.startValue}to ${item.data.endVALUE} , parse
                        ${item.data.parseTimes} ,
                        delete ${item.data.deleteTimes} times ${timestampToDate(item.StartTime)}` }}</div>
                </div>
            </div> -->


    </div>

</template>
<script>
import { getUserBehaviorsByParams } from '@/webpublicapi/userBehavior'
import moment from 'moment'
const I18N_KEY = {
    COUPON: 'coupon.',
}

export default {
    data() {
        return {
            I18N_KEY,
            custInfoId: "",//UserId	
            timeLineData: [],
            isLoading: false,
            // Pagination config
            pagination: {
                current: 1, //Default current page
                pageSize: 20, // Default items per page
                showSizeChanger: true, //Whether can change pageSize
                pageSizeOptions: ['50', '100', '200', '300', '500'], //Can switch items per page
                total: 0, // Show total data in pagination
                showTotal: total => `Total ${total} items`
            },

            columns: [
                {
                  title: "appSsid",
                  align: 'left',
                  dataIndex: 'appSsid',
                },
                {
                    title: "level",
                    align: 'left',
                    dataIndex: 'level',
                },
                {
                    title: "type",
                    align: 'left',
                    dataIndex: 'type',
                },
                {
                    title: "StartTime",
                    align: 'left',
                    dataIndex: 'StartTime',
                    scopedSlots: { customRender: 'StartTime' },

                },
                {
                    title: "pageName",
                    align: 'left',
                    dataIndex: 'pageName',
                },
                {
                    title: "elementName",
                    align: 'left',
                    dataIndex: 'elementName',
                },
                {
                    title: "data",
                    align: 'left',
                    dataIndex: 'data',
                    scopedSlots: { customRender: 'data' }
                },

            ],
            dataSource: []

        }
    },
    created() {


    },
    methods: {
        search() {
            if (!this.custInfoId) {
                this.$message.error('custInfoIdcannot be empty')
                return
            }
            this.isLoading = true
            let json = {
                "custInfoId": this.custInfoId,
            }
            getUserBehaviorsByParams(json).then(res => {
                if (res.code == 1000) {
                    this.timeLineData = res.data
                    // this.timeLineData=[...this.timeLineData].reverse()
                       this.timeLineData=this.timeLineData.sort(function(a,b){
                        return b.startTime > a.startTime ? 1 : -1
                       })
                    this.dataSource = this.timeLineData.slice(0, this.pagination.pageSize)
                    this.pagination.total = this.timeLineData.length
                    this.isLoading = false
                } else {
                    this.$message.error(res.msg)
                }

            })
        },
        timestampToDate(timestamp) {
            return moment(Number(timestamp)).format('YYYY-MM-DD HH:mm:ss');
        },
        // Handler function on pagination change
        handleTableChange(pagination, filters, sorter) {
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            pager.pageSize = pagination.pageSize;
            // Update pagination params
            this.pagination = pager;
            // Filter data based on pagination params
            this.dataSource = this.getDataByPage(pager);
        },
        // Function to get data based on pagination params
        getDataByPage({ current, pageSize }) {
            const startIndex = (current - 1) * pageSize;
            return this.timeLineData.slice(startIndex, startIndex + pageSize);
        },

    }
}
</script>
<style>
.timeLineItem {
    position: relative;
    height: 40px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    border-left: 1.5px solid #ceceec;
    padding-left: 24px;
    padding-top: 0px;
}

.yuan {
    width: 12px;
    height: 12px;
    background-color: #fff;
    border: 1px solid #1890ff;
    border-radius: 50%;
    position: absolute;
    left: -6px;
    top: -6px;
}

.contentText {
    margin-top: -10px;
}
</style>